// extracted by mini-css-extract-plugin
module.exports = {"mobile":"app_mobile__26qAL","not_mobile":"app_not_mobile__3B77e"};